import React from 'react';

import { Check } from 'lucide-react';

import { Span } from 'common/ui/Text';
import styles from 'css-module/components/www/_PricingV4.module.scss';

type Props = {
  feature: string;
};
export default function PricingV4CardFeature({ feature }: Props) {
  return (
    <li className={styles.pricingV4CardFeature}>
      <Check className={styles.cardFeatureIcon} size={24} />
      <Span>{feature}</Span>
    </li>
  );
}
